module.exports = __webpack_public_path__ + "img/大理1.83ef6148.jpg";